/* eslint-disable no-undefined */
import React, {Component} from 'react';
import './InitialCredentialsComponent.less';
import {FormInput} from '@homeaway/react-form-components';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {apiPost} from '../../util/api.client';
import SocialLoginComponent from '../SocialLoginComponent/SocialLoginComponent';
import authAccountTypes from '../../enums/AuthAccountTypes';
import umsSettings from '../../util/ums.settings';
import ClientLogger from '../../util/clientLogger';
import {TrackingContext} from '@homeaway/react-event-tracking';

const validate = require('validate.js');

class InitialCredentialsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emailAddress: '',
            errorMsg: '',
            disabled: true
        };
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({disabled: false});
    }

    triggerSubmit = (e) => {
        e.preventDefault();
        this.props.enableLoading();
        setTimeout(() => {
            this.submitForm();
        }, 800);
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
    }

    checkStatus = (response) => {
        switch (response.status) {
            case 200:
                return response.json();
            default:
                this.props.disableLoading();
                this.props.handleError(this.props.lingua.read('error.generic'));
                ClientLogger.logError(
                    `An error has occurred : ${response.status} - ${
                        response.statusText
                    }`
                );
                break;
        }
        return null;
    }

    checkAuthType(accountType, loginType) {
        return accountType.some((t) => t === loginType);
    }

    handleJson = (json) => {
        if (json) {
            if (authAccountTypes.isNotUndefined(json.authType)) {
                let pageName = authAccountTypes.SIGNUP;
                let status = [];
                let hasFacebook = this.checkAuthType(json.authType, authAccountTypes.FACEBOOK);
                let hasGoogle = this.checkAuthType(json.authType, authAccountTypes.GOOGLE);
                let hasUMS = this.checkAuthType(json.authType, authAccountTypes.UMS);
                let hasExpedia = this.checkAuthType(json.authType, authAccountTypes.EXPEDIA);

                if (hasUMS) {
                    pageName = authAccountTypes.UMS;
                    status = [authAccountTypes.UMS];
                } else {
                    if (hasFacebook) {
                        pageName = authAccountTypes.FACEBOOK;
                        status.push(authAccountTypes.FACEBOOK);
                    }
                    if (hasGoogle) {
                        pageName = authAccountTypes.GOOGLE;
                        status.push(authAccountTypes.GOOGLE);
                    }
                    if (hasExpedia) {
                        pageName = authAccountTypes.EXPEDIA;
                        status.push(authAccountTypes.EXPEDIA);
                    }
                }
                if (status.length === 0) {
                    if (umsSettings.isTCRequired(this.props.site)) {
                        // this is the SignUp scenario, so we need to update the pageName to TermsAndConditions only for the required EU brands
                        pageName = 'TermsAndConditions';
                    }
                    status = [authAccountTypes.SIGNUP];
                }
                this.props.performInitialBulkUpdate(pageName, this.state.emailAddress, status);
            }
        }
    }

    submitForm() {
        if (!this.validateEmail()) {
            return;
        }
        this.context.trigger('generic.click', {eventcategory: 'lex.auth', eventaction: 'email.submit'});
        const statusRequest = {
            emailAddress: this.state.emailAddress
        };
        // update this so we don't have to worry about rolling back the edge rule in test and stage
        const url = '/auth/aam/v3/status';
        apiPost(url, statusRequest)
            .then(this.checkStatus)
            .then(this.handleJson);
    }

    validateEmail() {
        let constraints = {
            from: {
                email: true
            }
        };
        let emailAddress = this.state.emailAddress.trim();
        let emailValid = !validate({from: emailAddress}, constraints);
        if (!emailValid) {
            this.props.disableLoading();
            this.setState({
                errorMsg: this.props.lingua.read('lex.email.invalid')
            });
        }
        return emailValid;
    }

    render() {
        return (
            <div className="text-center">
                <form
                    className="EmailField"
                    onSubmit={this.triggerSubmit}
                    noValidate
                >
                    <FormInput
                        id="lex-emailAddress"
                        name="emailAddress"
                        label={this.props.lingua.read(
                            'form.placeholder.emailAddress'
                        )}
                        value={this.state.emailAddress}
                        onChange={this.handleChange}
                        type="email"
                        autoComplete="email"
                        errorMsg={this.state.errorMsg}
                        disabled={this.state.disabled}
                        autoFocus
                    />
                    <div className="InitialCredentials">
                        <ButtonPrimary
                            type="submit"
                            id="lex-initial-button"
                            label={this.props.lingua.read('lex.initial.button')}
                            disabled={!this.state.emailAddress}
                            className="btn-lg"
                        >
                            <LoadingOverlay loading={this.props.isWaiting} />
                        </ButtonPrimary>
                    </div>
                </form>
                {!this.props.multiUserEnabled && (
                    <SocialLoginComponent
                        enableLoading={this.props.enableLoading}
                        disableLoading={this.props.disableLoading}
                        lingua={this.props.lingua}
                        handleError={this.props.handleError}
                        locale={this.props.locale}
                        onClose={this.props.onClose}
                        handleLoginSuccess={this.props.handleLoginSuccess}
                        updatePage={this.props.updatePage}
                        performBulkPageUpdate={this.props.performBulkPageUpdate}
                        setAuthJson={this.props.setAuthJson}
                        site={this.props.site}
                        expediaIconDisplayed={this.props.expediaIconDisplayed}
                        marketingOptOut={this.props.marketingOptOut}
                    />
                )}
            </div>
        );
    }
}

InitialCredentialsComponent.contextType = TrackingContext;
export default InitialCredentialsComponent;
